import * as agentDetailsActions from '../../constants/action-types';

// Common error handling
export const errorHandler = error => ({
  type: agentDetailsActions.ERROR_DETAILS,
  payload: error,
});
